import ReactOnRails from 'react-on-rails'
import ReactModal from 'react-modal'
import axios from 'axios'
import SwiperCore, { Pagination } from 'swiper'

import 'whatwg-fetch'
import smoothscroll from 'smoothscroll-polyfill'

import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import 'react-phone-number-input/style.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '@splidejs/splide/dist/css/splide.min.css'
import 'swiper/swiper-bundle.min.css'
import 'rc-slider/assets/index.css'

import '../helpers/isomorphic'
import '../helpers/pluralize'

import App from '../App'
import ShowMoreText from '../components/ShowMoreText'
import Footer from '../layout/Footer'
import { initClient as initClientI18n } from '../i18n'

axios.defaults.baseURL = '/api'

initClientI18n()

SwiperCore.use([Pagination])

// https://github.com/reactjs/react-modal/issues/576
ReactModal.setAppElement('body')

smoothscroll.polyfill()

ReactOnRails.register({
  App,
  ShowMoreText,
  Footer,
})
